/* eslint-disable no-useless-escape */
import clsx from 'clsx'
import {
	BarMultiSelect,
	Button,
	DateTimer,
	DropdownFull,
	Helper,
	Icon,
	Input,
	InputRadio,
	InputTextArea,
	Message,
	ModalConfirm,
	RadioGroups,
	Typography
} from 'components'
import type { Dayjs, ManipulateType } from 'dayjs'
import { useToast } from 'hooks'
import { usePushNotification } from 'hooks/usePushNotification'
import {
	Icons,
	PushNotificationsFormInputs,
	PushNotificationsProps,
	TypographyTypes
} from 'interfaces'
import {
	daysTypeData,
	endShedules,
	itemPushNotification,
	listDays,
	periodTypeData,
	pushNotificationTitleMessage,
	removeHTMLTags
} from 'lib'
import dayjs from 'lib/dayjs'
import React, { useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { configGenaral, validatePushDate, ValidatePushDateReturn } from 'utils'

interface dataModalInterface {
	icon?: string
	title?: string
	description?: string
	labelButton?: string
	labelButtonCancel?: string
	flexButton?: 'col' | 'row'
	actionConfirm: () => void
	actionCancel: () => void
}

export const PushNotification: React.FC<PushNotificationsProps> = ({
	totalData,
	onClickClose,
	setTotalData,
	setOpenSlide,
	listImagePush,
	deliveryActive,
	setListImagePush,
	setDeliveryActive,
	itemDatePushNotofication,
	setItemDatePushNotofication,
	watchTitle,
	watchDescription
}): JSX.Element => {
	const [edit, setEdit] = useState(0)
	const [publisDate, setPublisDate] = useState<string | Dayjs>('')
	const [dataCurrency, setDataCurrency] = useState<string | Dayjs>('')
	const [dateTypeNotification, setDateTypeNotification] = useState(
		daysTypeData[0]
	)
	const [periodTypeNotification, setPeriodTypeNotification] = useState(
		periodTypeData[0]
	)
	const [listDaysSeleted, setListDaysSeleted] = useState<string[]>([])
	const [endDateType, setEndDateType] = useState(daysTypeData[0])
	const { showToast } = useToast()
	const [endDate, setEndDate] = useState<string | Dayjs>('')
	const [endRadio, setEndRadio] = useState({
		id: '1',
		title: 'Never',
		value: 'never'
	})
	const [isSubmit, setIsSubmit] = useState(false)
	const [description, setDescription] = useState('')
	const MESSAGE_MAX_LENGTH = 140
	const [modalConfirm, setModalConfirm] = useState<number | null>(null)
	const [pushNotificationTitleMsgOptions, setpushNotificationTitleMsgOptions] =
		useState(() => {
			const dataContent = totalData.delivery_enhancements.push_notification
			if (
				dataContent.is_title === false &&
				dataContent.is_message === false &&
				deliveryActive.push_notification
			) {
				return '2'
			}
			return '1'
		})
	const [infoModalConfirm, setInfoModalConfirm] =
		useState<dataModalInterface | null>(null)

	const hasContentSchedule =
		totalData.delivery_enhancements.schedule.timing.release_date
	const hasContentRecurrence =
		totalData.delivery_enhancements.schedule.custom_recurrence
			?.repeating_schedule
	const hasContentFutureSchedule = !!(
		hasContentSchedule || hasContentRecurrence
	)
	const contentScheduleStartDate =
		totalData.delivery_enhancements.schedule.timing.release_date ||
		totalData.delivery_enhancements.schedule.custom_recurrence
			?.repeat_start_date
	const pushMinDate =
		contentScheduleStartDate &&
		dayjs.utc(contentScheduleStartDate).isAfter(dayjs())
			? dayjs.utc(contentScheduleStartDate).format('MM/DD/YYYY')
			: dayjs().format('MM/DD/YYYY')

	const {
		isValidFutureDate,
		isValidEndDateVsDataCurrency,
		handleChangeSchedule,
		handleChangeDataCurrency,
		handleChangeEndDate
	} = usePushNotification({
		showToast,
		setPublisDate,
		setDataCurrency,
		endDate,
		endRadio,
		setEndDate,
		dataCurrency,
		contentScheduleStartDate
	})
	const publishNow = itemDatePushNotofication === '3'

	const {
		register,
		setValue,
		handleSubmit,
		watch,
		getValues,
		formState: { errors }
	} = useForm<PushNotificationsFormInputs>({
		mode: 'all'
	})
	const titleFiles = watch('title')

	const registerInputFile = register?.(`image`)

	const rules = {
		title: {
			required: {
				value: pushNotificationTitleMsgOptions === '1',
				message: 'This field is required'
			}
		},
		message: {
			required: { value: false, message: 'This field is required' }
		}
	}

	const datePublish = dayjs(publisDate).utc().format('YYYY-MM-DDTHH:mm')

	const handleUploadImage = (file: File): void => {
		const fileSize = file.size
		const fileMb = fileSize / 1024 ** 2
		if (fileMb <= configGenaral.maxfileSizeMB) {
			const render = new FileReader()
			render.onload = e => {
				const uploadedObj = { file, url: e.target?.result as string }
				setListImagePush({
					asset_type: 'image',
					asset_url: uploadedObj.url,
					asset_name: uploadedObj.file.name
						.normalize('NFD')
						.replace(/[\u0300-\u036f]/g, '')
						.replace(/ /g, '-')
				})
			}
			render.readAsDataURL(file)
		} else {
			showToast(
				'Error',
				`Please select a file less than ${configGenaral.maxfileSizeMB}MB.`,
				'error'
			)
		}
	}

	const handleDeleteFileOne = (): void => {
		setListImagePush(undefined)
		setValue('image', '')
		setTotalData({
			...totalData,
			delivery_enhancements: {
				...totalData.delivery_enhancements,
				push_notification: {
					...totalData.delivery_enhancements.push_notification,
					image: ''
				}
			}
		})
	}

	const handleCancelModal = (): void => {
		setModalConfirm(null)
		setInfoModalConfirm(null)
	}

	const handleSave = (titlePush: string, releaseDate: string | null): void => {
		const getEndDate =
			endDate !== '' && endDate !== 'Invalid date'
				? dayjs.utc(endDate).format('YYYY-MM-DDTHH:mm')
				: null

		setDeliveryActive({
			...deliveryActive,
			push_notification: true
		})

		setTotalData({
			...totalData,
			delivery_enhancements: {
				...totalData.delivery_enhancements,
				push_notification: {
					...totalData.delivery_enhancements.push_notification,
					title: titlePush ?? '',
					message: description,
					is_message: pushNotificationTitleMsgOptions !== '2',
					is_title: pushNotificationTitleMsgOptions !== '2',
					timing: {
						release_date: releaseDate
					},
					custom_recurrence: {
						repeating_schedule: itemDatePushNotofication === '2',
						repeat_start_date:
							itemDatePushNotofication === '2'
								? dayjs.utc(dataCurrency).format('YYYY-MM-DDTHH:mm')
								: null,
						repeat_every_type:
							itemDatePushNotofication === '2'
								? (periodTypeNotification.value as string)
								: null,
						repeat_every_value:
							itemDatePushNotofication === '2'
								? (dateTypeNotification.id as number)
								: 1,
						repeat_on:
							itemDatePushNotofication === '2' ? `[${listDaysSeleted}]` : '',
						ends: {
							repeat_end_type:
								itemDatePushNotofication === '2' ? endRadio.value : '',
							repeat_end_date:
								itemDatePushNotofication === '2' ? getEndDate : null,
							after_ocurrences:
								itemDatePushNotofication === '2'
									? (endDateType.id as number)
									: 1
						}
					}
				}
			}
		})
		handleCancelModal()
		setOpenSlide(false)
	}

	const handleConfirmAction = (dataModal: dataModalInterface): void => {
		setModalConfirm(null)
		setInfoModalConfirm(dataModal)
		setModalConfirm(1)
	}

	const validateDate = (
		validateScheduling: ValidatePushDateReturn
	): boolean => {
		if (!validateScheduling.isValid) {
			showToast('Error', `${validateScheduling.message}`, 'error')
			return false
		}
		return true
	}

	const validateScheduling = validatePushDate(
		itemDatePushNotofication === '1'
			? datePublish === 'Invalid date'
				? ''
				: datePublish
			: '',
		hasContentSchedule,
		totalData.delivery_enhancements.schedule.timing.expiration_date
	)

	const onSubmit: SubmitHandler<PushNotificationsFormInputs> = values => {
		const dataConfirm = {
			title: 'Push notification scheduled!',
			description: 'Please confirm your notification’s time and date',
			icon: Icons.checkCircleTags,

			actionConfirm: () => {
				setPublisDate(dayjs.utc(hasContentSchedule).local())
				setItemDatePushNotofication('1')
				setModalConfirm(null)
				setInfoModalConfirm(null)
			},
			actionCancel: () => handleCancelModal()
		}
		const dataCancel = {
			title: 'Please reschedule your notification',
			description:
				'Since the content item is scheduled for a future date, please select Push Schedule or Push Recurrence to set an appropriate notification time.',
			icon: Icons.warning,
			actionConfirm: () => handleCancelModal(),
			actionCancel: () => handleCancelModal()
		}

		if (publishNow && hasContentFutureSchedule) {
			setInfoModalConfirm({
				description:
					'You can’t publish a notification before the content item. You can either reschedule it for a later time or use the content item’s publish date.',
				icon: Icons.warning,
				labelButton: 'Use the content item’s publish date.',
				labelButtonCancel: 'I’ll reschedule it.',
				flexButton: 'col',

				actionConfirm: () => handleConfirmAction(dataConfirm),
				actionCancel: () => handleConfirmAction(dataCancel)
			})
			setModalConfirm(1)
			return
		}

		if (itemDatePushNotofication === '1') {
			if (!validateDate(validateScheduling)) {
				return
			}
			handleSave(
				values.title,
				dayjs(publisDate).utc().format('YYYY-MM-DDTHH:mm')
			)
		}
		if (itemDatePushNotofication === '2') {
			const expirationDate =
				totalData.delivery_enhancements.schedule.timing.expiration_date
			if (expirationDate) {
				const expiration = dayjs.utc(expirationDate)
				const startMoment = dayjs.utc(dataCurrency)

				if (startMoment.isAfter(expiration)) {
					showToast(
						'Error',
						'The push recurrence start date cannot be later than the content expiration date.',
						'error'
					)
					return
				}

				if (endRadio.value === 'after_ocurrence') {
					const occurrences = endDateType.id as number
					const repeatValue = dateTypeNotification.id as number
					const repeatType = periodTypeNotification.value as ManipulateType
					const lastOccurrence = startMoment.add(
						occurrences * repeatValue,
						repeatType
					)

					if (lastOccurrence.isAfter(expiration)) {
						showToast(
							'Error',
							'The last push recurrence date cannot be later than the content expiration date.',
							'error'
						)
						return
					}
				}

				if (
					endRadio.value === 'specific_day' &&
					endDate !== '' &&
					endDate !== 'Invalid date'
				) {
					if (dayjs.utc(endDate).isAfter(expiration)) {
						showToast(
							'Error',
							'The push recurrence end date cannot be later than the content expiration date.',
							'error'
						)
						return
					}
				}
			}
			handleSave(values.title, null)
		}
		if (itemDatePushNotofication === '3' && !hasContentSchedule) {
			handleSave(values.title, null)
		}
	}

	useEffect(() => {
		const checkDateValidation = (): boolean => {
			const isAfterContentSchedule = (date: string | Dayjs): boolean => {
				if (!contentScheduleStartDate) return true
				return !dayjs
					.utc(date as string)
					.isBefore(dayjs.utc(contentScheduleStartDate))
			}

			if (itemDatePushNotofication === '3') {
				return true
			}
			if (
				itemDatePushNotofication === '1' &&
				publisDate !== '' &&
				isValidFutureDate(publisDate) &&
				isAfterContentSchedule(publisDate)
			) {
				return true
			}
			if (itemDatePushNotofication === '2') {
				if (
					dataCurrency !== '' &&
					isValidFutureDate(dataCurrency) &&
					isAfterContentSchedule(dataCurrency) &&
					endRadio.value !== 'specific_day'
				) {
					return true
				}
				if (
					dataCurrency !== '' &&
					isValidFutureDate(dataCurrency) &&
					isAfterContentSchedule(dataCurrency) &&
					endRadio.value === 'specific_day' &&
					endDate !== '' &&
					isValidFutureDate(endDate) &&
					isValidEndDateVsDataCurrency(dataCurrency, endDate)
				) {
					return true
				}
			}
			return false
		}

		if (pushNotificationTitleMsgOptions === '2') {
			setIsSubmit(checkDateValidation())
		} else {
			const titleMessageFiles = watch('title')
			if (titleMessageFiles && titleMessageFiles.trim() !== '') {
				setIsSubmit(checkDateValidation())
			} else {
				setIsSubmit(false)
			}
		}
	}, [
		pushNotificationTitleMsgOptions,
		description,
		dataCurrency,
		endRadio,
		endDate,
		itemDatePushNotofication,
		publisDate,
		contentScheduleStartDate,
		watch
	])

	useEffect(() => {
		if (pushNotificationTitleMsgOptions === '2') {
			setValue('title', watchTitle || totalData.set_up.title)

			if (watchDescription || totalData.set_up.description) {
				setDescription(
					removeHTMLTags(watchDescription || totalData.set_up.description || '')
				)
			}
		} else {
			setValue('title', '')
			setDescription('')
		}
	}, [
		pushNotificationTitleMsgOptions,
		totalData.set_up.title,
		totalData.set_up.description,
		watchTitle,
		watchDescription,
		setValue
	])

	useEffect(() => {
		const dataContent = totalData.delivery_enhancements.push_notification

		if (dataContent.title || dataContent.message) {
			if (
				dataContent.is_title === false &&
				dataContent.is_message === false &&
				deliveryActive.push_notification
			) {
				setpushNotificationTitleMsgOptions('2')
			} else if (
				dataContent.is_title === true &&
				dataContent.is_message === true &&
				deliveryActive.push_notification
			) {
				setpushNotificationTitleMsgOptions('1')
			}
		}

		if (totalData.delivery_enhancements.push_notification.is_title) {
			setValue('title', totalData.delivery_enhancements.push_notification.title)
		}
		if (totalData.delivery_enhancements.push_notification.is_message) {
			setDescription(
				removeHTMLTags(
					totalData.delivery_enhancements.push_notification.message
				)
			)
		}
		if (totalData.delivery_enhancements.push_notification.image) {
			setListImagePush({
				asset_type: 'image',
				asset_url: totalData.delivery_enhancements.push_notification.image
			})
		}

		if (
			!dataContent.custom_recurrence?.repeating_schedule &&
			dataContent.timing.release_date
		) {
			setItemDatePushNotofication('1')
			setPublisDate(
				dataContent.timing?.release_date !== ''
					? dayjs.utc(dataContent.timing?.release_date).local()
					: ''
			)
		}

		if (
			totalData.delivery_enhancements.push_notification.custom_recurrence
				?.repeating_schedule === false ||
			!totalData.delivery_enhancements.push_notification.custom_recurrence
				?.repeating_schedule
		) {
			if (
				totalData.delivery_enhancements.push_notification.timing
					.release_date === '' &&
				deliveryActive.push_notification
			) {
				setItemDatePushNotofication('3')
			}
			const releaseDate =
				totalData.delivery_enhancements.push_notification.timing?.release_date

			setPublisDate(releaseDate ? dayjs.utc(releaseDate).local() : '')
		} else {
			setItemDatePushNotofication('2')
			setDataCurrency(
				totalData.delivery_enhancements.push_notification.custom_recurrence
					?.repeat_start_date !== ''
					? dayjs
							.utc(
								totalData.delivery_enhancements.push_notification
									.custom_recurrence?.repeat_start_date
							)
							.local()
					: ''
			)
			const auxDay = daysTypeData.find(
				item =>
					item.id ===
					totalData.delivery_enhancements.push_notification.custom_recurrence
						?.repeat_every_value
			)
			if (auxDay) {
				setDateTypeNotification(auxDay)
			}
			const auxPeriod = periodTypeData.find(
				item =>
					item.value ===
					totalData.delivery_enhancements.push_notification.custom_recurrence
						?.repeat_every_type
			)
			const repeatOn =
				totalData.delivery_enhancements.push_notification.custom_recurrence
					?.repeat_on
			if (repeatOn) {
				setListDaysSeleted(
					(
						totalData.delivery_enhancements.push_notification.custom_recurrence
							?.repeat_on as string
					)
						.replace(/[\[\]']/g, '')
						.split(',')
				)
			}
			if (auxPeriod) {
				setPeriodTypeNotification(auxPeriod)
			}
			const customRecurrence =
				totalData.delivery_enhancements.push_notification.custom_recurrence

			if (customRecurrence?.ends?.repeat_end_type) {
				const auxEndRadio = endShedules.find(
					item => item.value === customRecurrence.ends.repeat_end_type
				)

				if (auxEndRadio) {
					setEndRadio(auxEndRadio)
				}
				if (customRecurrence?.ends?.after_ocurrences) {
					const occurrences = parseInt(
						customRecurrence.ends.after_ocurrences as unknown as string,
						10
					)
					const auxEndDateType = daysTypeData.find(
						item => item.id === occurrences
					)
					if (auxEndDateType) {
						setEndDateType(auxEndDateType)
					}
				}
			}

			const backendEndDate =
				totalData?.delivery_enhancements?.push_notification.custom_recurrence
					?.ends?.repeat_end_date

			// Only update endDate if backend has a value
			// Don't clear it if user manually selected a date
			if (backendEndDate && backendEndDate !== '') {
				setEndDate(dayjs.utc(backendEndDate).local())
			} else if (edit === 0) {
				// Only clear on first load (edit === 0), not on subsequent updates
				setEndDate('')
			}
		}
		const aux = edit + 1
		setEdit(aux)
	}, [totalData])

	useEffect(() => {
		if (hasContentFutureSchedule && itemDatePushNotofication === '3') {
			setItemDatePushNotofication('4')
		}
	}, [hasContentFutureSchedule])

	const cleanPushNotification = (): void => {
		setTotalData({
			...totalData,
			delivery_enhancements: {
				...totalData.delivery_enhancements,
				push_notification: {
					title: '',
					message: '',
					is_title: true,
					is_message: true,
					image: '',
					timing: { release_date: null },
					custom_recurrence: {
						repeating_schedule: false,
						repeat_start_date: null,
						repeat_every_type: null,
						repeat_every_value: 0,
						repeat_on: '',
						ends: {
							repeat_end_type: '',
							repeat_end_date: null,
							after_ocurrences: 0
						}
					}
				}
			}
		})
		setItemDatePushNotofication('4')
		setDeliveryActive({
			...deliveryActive,
			push_notification: false
		})
		handleCancelModal()
		setOpenSlide(false)
	}

	const isDisabled =
		itemDatePushNotofication === '4' && deliveryActive.push_notification
			? false
			: !isSubmit

	const handleSavePushNotification = (): void => {
		switch (itemDatePushNotofication) {
			case '4':
				cleanPushNotification()
				break

			default:
				onSubmit(getValues())
				break
		}
	}

	return (
		<div className="h-full flex flex-col">
			<div className="flex-1  pr-2">
				<div className="mt-6">
					{itemPushNotification.map(item => {
						const isPublishNowDisabled =
							item.id === '3' && hasContentFutureSchedule
						return (
							<div key={item.id}>
								<InputRadio
									item={item}
									disabled={isPublishNowDisabled}
									defaultChecked={itemDatePushNotofication}
									setItemRecurrence={setItemDatePushNotofication}
								/>
								{isPublishNowDisabled && (
									<Typography
										title="Not available when content has a scheduled or recurring publish date."
										type={TypographyTypes.span}
										className="text-red-500 ml-7 -mt-1 mb-2 block"
										fontLeading="12/15"
									/>
								)}
							</div>
						)
					})}
				</div>

				{itemDatePushNotofication !== '4' && (
					<form
						key={edit}
						onSubmit={handleSubmit(onSubmit)}
						className="mt-5 flex flex-col gap-6 "
					>
						<div>
							<Typography
								title="Do you want to use the Content Item Title and Message for the push notification?"
								type={TypographyTypes.span}
								className={clsx('text-gray-9 !font-normal')}
								fontLeading="15/18"
							/>

							<div className="my-3">
								{pushNotificationTitleMessage.map(item => (
									<InputRadio
										item={item}
										key={item.id}
										defaultChecked={pushNotificationTitleMsgOptions}
										setItemRecurrence={setpushNotificationTitleMsgOptions}
									/>
								))}
							</div>

							<div className="mt-5 border border-blue-primary rounded-3xl p-4">
								<Typography
									title="Title"
									type={TypographyTypes.span}
									className={clsx('text-gray-9 !font-bold')}
									fontLeading="15/18"
								/>
								<Input
									limit
									name="title"
									className={
										pushNotificationTitleMsgOptions === '2' ? 'mb-2' : 'mb-4'
									}
									disabled={pushNotificationTitleMsgOptions === '2'}
									register={register}
									rules={rules.title}
									error={errors.title}
									watchValue={titleFiles}
									setValueInput={setValue}
									placeholder={
										pushNotificationTitleMsgOptions === '2'
											? watchTitle ||
											  totalData.set_up.title ||
											  'Content title will be used'
											: 'Enter Title'
									}
									cantLimit={configGenaral.maxTitlePush}
								/>

								<Typography
									title="Message"
									type={TypographyTypes.span}
									className={clsx('text-gray-9 !font-bold')}
									fontLeading="15/18"
								/>
								<InputTextArea
									name="textArea"
									textValue={description}
									maxLength={MESSAGE_MAX_LENGTH + 1}
									textAreaClassName="!h-[140px] !resize-none"
									setTextValue={setDescription}
									color="Gray3"
									disabled={pushNotificationTitleMsgOptions === '2'}
									placeholder={
										pushNotificationTitleMsgOptions === '2'
											? removeHTMLTags(
													watchDescription || totalData.set_up.description || ''
											  ) || 'Content message will be used'
											: 'Enter Message'
									}
								/>

								{description.length > MESSAGE_MAX_LENGTH && (
									<Message
										type="error"
										text={`The message must have a maximum of ${MESSAGE_MAX_LENGTH} characters`}
									/>
								)}

								<input
									id="pdf"
									type="file"
									className="hidden"
									{...registerInputFile}
									onChange={event => {
										if (event.target.files) {
											handleUploadImage(event.target.files[0])
										}
									}}
									accept="image/*"
								/>
								<div
									className={`mt-5 ${
										listImagePush === undefined
											? 'flex flex-row justify-between'
											: ''
									}`}
								>
									<Typography
										fontLeading="12/12"
										title="Custom Image"
										type={TypographyTypes.span}
									/>
									{listImagePush === undefined ? (
										<div className="flex items-center gap-2 mt-8">
											<Button
												type="button"
												label="Upload"
												color="Transparent"
												iconLeft={Icons.upload}
												className="!min-w-[130px]"
												onClick={() => {
													const input = document.getElementById(`pdf`)
													if (input) input.click()
												}}
											/>
											<Helper
												text="Supported formats (JPG, JPEG, PNG, PDF). Max image size 10 MB. Min. Resolution: 1080px by 1080px"
												className="relative"
											/>
										</div>
									) : (
										<div className="relative">
											<button
												type="button"
												onClick={handleDeleteFileOne}
												className="absolute -top-1 right-1 bg-gray-18 p-1 rounded-full border-2 border-gray-3"
											>
												<Icon src={Icons.close} className="w-3 h-3" />
											</button>
											<img
												src={listImagePush.asset_url}
												alt="preview"
												className="rounded-lg w-full max-h-[300px] min-h-[300px]"
											/>
										</div>
									)}
								</div>
								<div className="mt-6">
									{itemDatePushNotofication === '1' && (
										<div key={itemDatePushNotofication}>
											<DateTimer
												className="mt-2"
												validate={pushMinDate}
												icon={Icons.calendar}
												setDate={handleChangeSchedule}
												initialValue={publisDate}
												title="Release date and time"
												placeholderInput="Pick date"
												helper
												textHelper="Time and date reflects your local time."
												autoInitialize
											/>
										</div>
									)}
									{itemDatePushNotofication === '2' && (
										<div key={itemDatePushNotofication}>
											<div className="w-full flex justify-between items-center mb-2">
												<Typography
													type={TypographyTypes.span}
													fontLeading="15/18"
													title="Specific Date"
												/>
												<Helper text="Time and date reflects your local time." />
											</div>
											<DateTimer
												line={false}
												className="mt-2"
												validate={pushMinDate}
												setDate={handleChangeDataCurrency}
												icon={Icons.calendarCheck}
												initialValue={dataCurrency}
												autoInitialize
											/>
											<div className="flex items-center gap-2 mt-2">
												<Typography
													title="Repeat every"
													type={TypographyTypes.span}
													fontLeading="15/18"
												/>
												<DropdownFull
													item={dateTypeNotification}
													list={daysTypeData}
													setItem={setDateTypeNotification}
													className="min-w-[140px]"
												/>
												<DropdownFull
													item={periodTypeNotification}
													list={periodTypeData}
													setItem={setPeriodTypeNotification}
													className="min-w-[140px]"
												/>
											</div>

											{periodTypeNotification.value === 'week' && (
												<div className="mt-2">
													<Typography
														title="Repeat On"
														type={TypographyTypes.span}
														fontLeading="15/18"
														className="mb-2"
													/>
													<BarMultiSelect
														list={listDays}
														listSeleted={listDaysSeleted}
														setListSeleted={setListDaysSeleted}
													/>
												</div>
											)}

											<RadioGroups
												name="ends"
												title="Ends"
												endDate={endDate}
												checked={endRadio}
												validate={pushMinDate}
												options={endShedules}
												setEndDate={handleChangeEndDate}
												setChecked={setEndRadio}
												endDdateType={endDateType}
												setEndDateType={setEndDateType}
												autoInitializeEndsOn={false}
											/>
										</div>
									)}
								</div>
							</div>
						</div>

						<ModalConfirm
							open={modalConfirm !== null}
							setOpen={() => handleCancelModal()}
							onClickConfirm={() => infoModalConfirm?.actionConfirm()}
							handleCancel={() => infoModalConfirm?.actionCancel()}
							icon={infoModalConfirm?.icon}
							title={infoModalConfirm?.title}
							descripcion={infoModalConfirm?.description}
							buttonLabel={infoModalConfirm?.labelButton}
							buttonLabelCancel={infoModalConfirm?.labelButtonCancel}
							hasCancel
							flexButton={infoModalConfirm?.flexButton}
						/>
					</form>
				)}
			</div>

			<div className="flex-shrink-0 px-4 py-3 flex justify-between">
				<Button
					type="button"
					label="Cancel"
					color="Transparent"
					className="!min-w-[130px]"
					onClick={onClickClose}
				/>
				<Button
					label="Save"
					type={itemDatePushNotofication === '4' ? 'button' : 'submit'}
					onClick={handleSavePushNotification}
					color="Primary"
					className="!min-w-[130px]"
					disabled={isDisabled}
				/>
			</div>
		</div>
	)
}
